import React from 'react'
import { AppBar, Box } from '@mui/material'

import { HeaderAction } from './HeaderAction'
import CustomBadge from 'components/Shared/Badge'

const TextAnalysisHeader = () => {
  return (
    <AppBar
      position="static"
      elevation={0}
      data-testid="ta-header"
      sx={{
        backgroundColor: 'transparent',
        color: 'text.primary',
        height: '10rem',
      }}
    >
      <Box>
        {/* Top row: Button (and future pagination) */}
        <Box
          sx={{
            height: '4rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <HeaderAction />
        </Box>

        {/* Bottom row: Title with Beta badge */}
        <Box>
          <CustomBadge
            title="Text analysis"
            contentType="Header"
            badgeType="Beta"
          />
        </Box>
      </Box>
    </AppBar>
  )
}

export default React.memo(TextAnalysisHeader)
